$.fn.EventFilters = function() {
  let self = this
  let buffer_key = '';
  page_uri = window.location.href;

  let output = self.next('.grid-row').find('.grid');
  output.addClass('--has-filters')

  self.loadEvents = function() {
    var temp_buffer_key = '';
    if (output.length <= 0) {
      return false;
    }
    var terms = [];
    self.find('.--selected').each(function() {
      terms.push($(this).attr('data-slug'));
    })
    var search_key = self.find('.event-filters__search-field').val();

    if ($('body.page-programmation, body.page-programming').length > 0) {
      var variables = '?';
      if (terms.length > 0) {
        variables += 'c=' + terms.join(',');
      }
      if (search_key != '') {
        if (variables != '?') {
          variables += '&'
        }
        variables += 'sk=' + search_key
      }
      if (variables == '?') {
        variables = page_uri
      }
      window.history.pushState('programmation', 'Programmation', variables);
    }
    buffer_key = temp_buffer_key = terms.toString();
    var limit = -1;
    if (output.attr('data-limit')) {
      limit = output.attr('data-limit');
    }

    $.ajax({
  			url: self.attr('data-action'),
  			data : {
          action: "filter_events",
          terms: terms,
          limit: limit,
          search_key: search_key,
        },
  			type: 'POST',
  			beforeSend:function(xhr){
          output.addClass('loading')
          self.next('.grid-row').css('--max-height', output.height() + 'px');
  			},
  			success:function(data){
          if (temp_buffer_key == buffer_key) {
            if ($(data).find('.grid').length > 0) {
              output.html($(data).find('.grid').html());
            } else {
              output.html($(data));
            }
            self.next('.grid-row').css('--max-height', output.height() + 'px');
            output.removeClass('loading')
          }
  			}
  		});
  }

  self.find('.js-filter-event').click(function() {
    $(this).toggleClass('--selected');
    self.loadEvents();
  })

  self.find('.js-clear-all').click(function() {
    self.find('.js-filter-event').removeClass('--selected');
    self.loadEvents();
  })

  self.find('.js-search').addClass('--search-context')
  self.find('.js-search').click(function() {
    if ($(this).hasClass('--search-context')) {
      self.loadEvents();
      return false;
    }
  })

  return function() {

    return self
  }()
}
